import { mountApplications } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/wikis/show.js?vue3';
import { mountMoreActions } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/wikis/more_actions.js?vue3';

mountApplications();
mountMoreActions();
